import React, {Component} from 'react';
import couterpart from 'counterpart';
// import DatePicker from 'react-datepicker';
import { withRouter } from 'react-router-dom';
// import {Prompt} from 'react-router-dom'
import { FaPrint,FaRegSave,FaCopy} from 'react-icons/fa';
import {TiArrowBackOutline, TiRefresh} from 'react-icons/ti';
import Dialog from 'react-bootstrap-dialog';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker';
import { MdImportExport } from 'react-icons/md';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import TalkDetails from './TalkDetails';

import MenuComponent2 from './MenuComponent2';
import WorkOrderDataService from '../services/WorkOrderDataService';
import WorkOrderAdditions from './WorkOrderAdditions';
import WorkOrderImages from './WorkOrderImages';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';
import UserDataService from '../services/UserDataService';
import ItemDataService from '../services/ItemDataService';
import ItemDetailsViewById from './ItemDetailsViewById';
import MasterDataService from '../services/MasterDataService';
import NoteDataService from '../services/NoteDataService';

import {ICON_COLOR} from '../icon';

import '../css/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import queryString from 'query-string'
import {ToastsContainer, ToastsStore} from 'react-toasts';
import { EVENT_NAME_UPDATE_WO, EVENT_NAME_UPDATE_WO_DETAILS, ITEM_TYPE_DA_INOX, ITEM_TYPE_DA_KHONG, ITEM_TYPE_LEN_DA, ITEM_TYPE_LEN_INOX, ITEM_TYPE_LEN_KHONG, ITEM_TYPE_NONE, STATUS_DA_DA_SX, STATUS_DA_HOAN_THANH, STATUS_DA_MOI, STATUS_LEN_DA_SX, STATUS_LEN_HOAN_THANH, STATUS_LEN_MOI, STATUS_NAME_DA, STATUS_NAME_LEN, STATUS_SS_SX_DA, STATUS_SS_SX_LEN } from '../constants';
import DataUtil from '../utilities/DataUtil';

class WorkOrderDetails extends Component {
    constructor() {
        super();
        this.state = {
            backClicked: false,
            show: false,
            workOrder: {isDirty: false},
            workOrderId: null,
            updated: false,
            options: "",
            selectedOption: null,
            startDate: null,
            endDate: null,
            items: [],
            shipModes: [
                "Standard Shipping",
                "Priority",
                "Express"
            ],
            shapeDesigns: [],
            colors: [],
            fonts: []            
        };
    };

    componentDidMount () {
        this.loadItems();
        MasterDataService.retrieveAllStatus().then(data => {
            this.setState({ allStatus:  data}) 
        });

        MasterDataService.retrieveShapes().then(data => {
            this.setState({ shapeDesigns:  data}) 
        });

        MasterDataService.retrieveFonts().then(data => {
            let ffonts = [];
            let fonts = [];
            for(let i=0; i<data.length; i++){
                if (ffonts.indexOf(data[i].name) < 0){
                    ffonts.push(data[i].name);
                    fonts.push(data[i]);
                } 
            }            
            this.setState({ fonts:  fonts}) 
        });

        MasterDataService.retrieveColors().then(data => {
            let fcolors = [];
            let colors = [];
            for(let i=0; i<data.length; i++){
                if (fcolors.indexOf(data[i].nameVn) < 0){
                    fcolors.push(data[i].nameVn);
                    colors.push(data[i]);
                } 
            }
            this.setState({ colors:  colors}) 
        });

        const { id } = this.props.match.params;
        this.loadWorkOrder(`${id}`);
    }

    loadItems(){
        ItemDataService.retrieveItems().then(data =>{
            this.setState({ 
                items: data
            });
        });
    }

    loadWorkOrder(id){
        WorkOrderDataService.retrieveById(id).then(data => {
            this.setState({ 
                workOrderId: id,
                workOrder:  data,
                workOrderOrg: JSON.parse(JSON.stringify(data))
            });
            
        });

        NoteDataService.retrieveNotesByWorkOrder(id).then(data =>{
            this.setState({ 
                notes: data
            }); 
        });        

        if (AuthenticationService.isAdmin()){
            UserDataService.retrieveWorkers().then(data => {
                var len = data.length;
                var selectOptions = [];
                for(var i=0; i<len; i++){
                    selectOptions.push({key:data[i].id, label: data[i].firstName + data[i].lastName, value: data[i].id})
                }
                this.setState({selectOptions: selectOptions});
            });
        }
    }

    handleUpdate (){
        this.setState({
            updated: true
        });  
    }

    handleQtyChange(e){
        // var newValue = e.target.value;
        // this.setState(prevState => ({
        //     workOrder: {
        //       ...prevState.workOrder,                   
        //       qty: newValue,
        //       isDirty: true                  
        //     }
        // }));        
    }

    handleLengthSizeChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              lengthSize: newValue,
              isDirty: true                  
            }
        }));  
    }

    handleShipToChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              shipTo: newValue,
              isDirty: true                  
            }
        }));  
    }    

    handleUrgentChange(e){
        var newValue = e.target.checked? 1 : 0;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              isUrgentByCustomer: newValue,
              isDirty: true                  
            }
        }));   
    }

    handleGhiThiepChange(e){
        var newValue = e.target.checked? '1': '0';
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              ghiThiep: newValue                  
            }
        }));   
    }

    handleSkuChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              sku: newValue,
              isDirty: true                  
            }
        }));
    }

    handleColorMaterialChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              colorMaterial: newValue,
              isDirty: true                  
            }
        }));   
    }

    handleWorkerChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              worker: newValue,
              isDirty: true                  
            }
        }));        
    }

    handlePersonalizationChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              personalization: newValue,
              isDirty: true                  
            }
        }));        
    }

    handleSpecialNoteChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              notesInternal: newValue,
              isDirty: true                   
            }
        }));
    }

    handleYcdbShippingChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              ycdbShipping: newValue                   
            }
        }));
    }     

    handleSelectChange(e){
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        //var dd2 = String(today.getDate() + 2).padStart(2, '0');
        var MM= String(today.getMonth() + 1).padStart(2, '0'); 
        var yyyy = today.getFullYear();

        today = yyyy + '/' + MM + '/' + dd;
        //var endDate = yyyy + '/' + MM + '/' + dd2;
        var value = e.target[e.target.selectedIndex].value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              worker: value,
              startDate: today,
              isDirty: true                   
            }
        }));
    };

    handleEndDateChange(date){
        var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              endDate: sDate,
              isDirty: true                   
            }
        }));
    }

    handleStartDateChange(date){
        var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              startDate: sDate,
              isDirty: true                   
            }
        }),() =>{
            
        });
    }

    saveInfo(e){
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              isDirty: false                  
            }
        }));
        // if (this.state.workOrderOrg.status === 40 || 
        //     this.state.workOrderOrg.status === 41 || this.state.workOrderOrg.status === 42) {
        //     if (this.state.workOrderOrg.personalization !== this.state.workOrder.personalization){
        //         this.dialog.showAlert(couterpart.translate("msg_change_wo_per_forbidden"));
        //         return;
        //     }
        // }

        //Dat Chia tho
        if (this.state.workOrder.status === 55 ) {
            if (this.state.workOrder.worker === undefined || this.state.workOrder.worker === null || this.state.workOrder.worker === '' || this.state.workOrder.worker < 1){
                this.dialog.showAlert(couterpart.translate("msg_change_wo_assign_forbidden"));
                return;
            }
        }         
        //Xi/Vo Bao
        if (this.state.workOrderOrg.status === 43 || this.state.workOrderOrg.status === 44) {
            if (this.state.workOrderOrg.personalization !== this.state.workOrder.personalization ||
                this.state.workOrderOrg.colorMaterial !== this.state.workOrder.colorMaterial ||
                this.state.workOrderOrg.lengthSize !== this.state.workOrder.lengthSize){
                this.dialog.showAlert(couterpart.translate("msg_change_wo_forbidden"));
                return;
            }
        }  
        //Khac/Cat      
        if ((this.state.workOrderOrg.status === 38 || this.state.workOrderOrg.status === 39) && 
            this.state.workOrderOrg.personalization !== this.state.workOrder.personalization){
            this.dialog.show({
                title: couterpart.translate("msg_title_confirm"),
                body: couterpart.translate("msg_change_wo_confirm"),
                actions: [
                    Dialog.CancelAction(),
                    Dialog.OKAction(() =>{
                        WorkOrderDataService.updateWorkOrder(this.state.workOrder).then(data => {
                            var msg = couterpart.translate("msg_saved_info");
                            if (data.message === undefined){
                                if (data.ret < 1){
                                    msg = couterpart.translate("msg_saved_error");
                                }
                            }else{
                                msg = couterpart.translate("msg_saved_error");
                            }
                            ToastsStore.info(msg);
                            // this.loadWorkOrder(this.state.workOrder.id);
                            this.backToList();
                        });
                    })
                ],
                bsSize: 'small',
                onHide: (dialog) => {
                    dialog.hide()
                    console.log('closed by clicking background.')
                }
            });                 
        } else {      
            this.dialog.show({
                title: couterpart.translate("msg_title_confirm"),
                body: couterpart.translate("msg_change_confirm"),
                actions: [
                    Dialog.CancelAction(),
                    Dialog.OKAction(() =>{
                        this.setState(prevState => ({
                            workOrder: {
                                ...prevState.workOrder,                   
                                eventName: AuthenticationService.getRole() + "_" + EVENT_NAME_UPDATE_WO_DETAILS,             
                            }
                        }), () => {
                            WorkOrderDataService.updateWorkOrder(this.state.workOrder).then(data => {
                                var msg = couterpart.translate("msg_saved_info");
                                if (data.message === undefined){
                                    if (data.ret < 1){
                                        msg = couterpart.translate("msg_saved_error");
                                    }
                                }else{
                                    msg = couterpart.translate("msg_saved_error");
                                }
                                ToastsStore.info(msg);
                                // this.loadWorkOrder(this.state.workOrder.id);
                                this.backToList();
                            });
                        });
                    })
                ],
                bsSize: 'small',
                onHide: (dialog) => {
                    dialog.hide()
                    console.log('closed by clicking background.')
                }
            });
        }
    }

    handlePrint(e){
        this.props.history.push("/workOrders/print/" + this.state.workOrderId);
    }

    cloneInfo(e){
        WorkOrderDataService.cloneWorkOrder(this.state.workOrder).then(data => {
            var msg = couterpart.translate("msg_clone_info");
            if (data.message === undefined){
                if (data.id < 1){
                    msg = couterpart.translate("msg_clone_error");
                 }
            }else{
                msg = couterpart.translate("msg_clone_error");
            }
            ToastsStore.info(msg);
            if (data.id > 0){
                this.loadWorkOrder(data.id);
                this.props.history.push("/workOrders/edit/" + data.id);
            }
        });
    }

    renderOption(option){
        return (
            <option key={option.key} value={option.value}>{option.label}</option>
        );
    }

    handleClose () {
        this.setState({show: false}); 
    }

    handleShow () {
        this.setState({show: true});
    }

    renderItemList(){
        if (this.state.items === undefined || this.state.items === null || this.state.items.length < 1){
            return (<></>);
        }
        return(
            <div>
                <input type="text" name="font" size="16" className="inputBox"
                    list="skus"
                    defaultValue={this.state.workOrder.sku}
                    onChange={this.handleItemChange.bind(this)}/>
                <datalist id="skus">
                    { this.state.items.map(x => <option value={x.sku} key={x.id}>{x.sku}</option>) }
                </datalist>
            </div>          
        );        
    }

    renderItemSelector () {
      
        return(
            <div>
                    <button className="myButton" type="button" onClick={this.handleShow.bind(this)}>...</button>
                    <Modal show={this.state.show} onHide={this.handleClose.bind(this)}>
                        <Modal.Header closeButton>
                        <Modal.Title>Chon sku</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <select defaultValue={this.state.workOrder.sku} className="selectBox"
                                onChange={this.handleItemChange1.bind(this)}>
                                { this.state.items.map(x => <option value={x.sku} key={x.id}>{x.sku}</option>) }
                            </select>                            
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose.bind(this)}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={this.handleClose.bind(this)}>
                            Select
                        </Button>
                        </Modal.Footer>
                    </Modal> 
        </div>);   
    }

    renderShippingList(){
        return(
            <select defaultValue={this.state.workOrder.carrierServiceRequested} className="selectBox"
                onChange={this.handleShippingModeChange.bind(this)}>
                { this.state.shipModes.map(x => <option value={x} key={x}>{x}</option>) }
            </select>
        );
    }

    handleDesignLevelModeChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              type: newValue,
              isDirty: true                  
            }
        }));
    }    

    renderDesignLevelList(){
        return(
            <select value={this.state.workOrder.type} className="selectBox"
                onChange={this.handleDesignLevelModeChange.bind(this)}>
                <option value={0} key={0}>0</option>
                <option value={1} key={1}>1</option>
            </select>
        );
    }

    renderColorList(){
        if (this.state.colors === undefined || this.state.colors === null || this.state.colors.length < 1){
            return (<></>);
        }        
        return(
            <div>
                <input type="text" name="colorMaterial" size="5" className="inputBox"
                    list="colors"
                    defaultValue={this.state.workOrder.colorMaterial}
                    onChange={this.handleColorMaterialChange.bind(this)}/>
                <datalist id="colors">
                    { this.state.colors.map(x => <option value={x.nameVn} key={x.nameVn}>{x.nameVn}</option>) }
                </datalist>
            </div>                           
        );
    }

    renderFontList(){
        if (this.state.fonts === undefined || this.state.fonts === null || this.state.fonts.length < 1){
            return (<></>);
        }        
        return(
            <div>
                <input type="text" name="font" size="5" className="inputBox"
                    list="fonts"
                    defaultValue={this.state.workOrder.font}
                    onChange={this.handleFontChange.bind(this)}/>
                <datalist id="fonts">
                    { this.state.fonts.map(x => <option value={x.name} key={x.name}>{x.name}</option>) }
                </datalist>
            </div>                           
        );
    }

    renderTypeList(){
        if (this.state.shapeDesigns === undefined || this.state.shapeDesigns === null || this.state.shapeDesigns.length < 1){
            return (<></>);
        }        
        return(
            <div>
                <input type="text" name="shapeDesign" size="5" className="inputBox"
                    list="shapeDesigns"
                    defaultValue={this.state.workOrder.shapeDesign}
                    onChange={this.handleTypeChange.bind(this)}/>
                <datalist id="shapeDesigns">
                    { this.state.shapeDesigns.map(x => <option value={x.name} key={x.name}>{x.name}</option>) }
                </datalist>
            </div>                           
        );
    }    

    handleItemChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              sku: newValue,
              isDirty: true                  
            }
        }));   
    }

    handleItemChange1(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              sku: newValue,
              isDirty: true                  
            }
        }));   
    }

    handleShippingModeChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              carrierServiceRequested: newValue,
              isDirty: true                  
            }
        }));
    }

    handleTypeChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              shapeDesign: newValue,
              isDirty: true                  
            }
        }));   
    }

    renderWorkerByRole(){
        if (!AuthenticationService.isAdmin()){
            return (<label>{this.state.workOrder.workerFullName}</label>);
        }

        if((this.state.selectOptions ===undefined) || (this.state.selectOptions === null)){
            return (<></>);
        }
        return(
        <select defaultValue={this.state.workOrder.worker} className="selectBox"
            onChange={this.handleSelectChange.bind(this)}>
            <option key="" value="">{couterpart.translate("work_order_worker_info")}</option>
            {this.state.selectOptions !== undefined && this.state.selectOptions.map(option =>this.renderOption(option))}
        </select>
        );
    }

    renderEditButtons(){
        if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()){
            return (<></>);
        }

        if (AuthenticationService.isAdmin()){
            return(
                <table>
                <tbody>
                <tr>
                    <td colSpan="4">
                        <button className="myButton" type="button" 
                        onClick={this.saveInfo.bind(this)}>
                        <FaRegSave color={ICON_COLOR}/>
                        &nbsp;{couterpart.translate('button_save')}</button>
                    </td>
                    <td colSpan="4">&nbsp;
                        <button className="myButton" type="button" 
                        onClick={this.handlePrint.bind(this)}>
                        <FaPrint color={ICON_COLOR}/>
                        &nbsp;{couterpart.translate('button_print')}&nbsp;&nbsp;&nbsp;&nbsp;</button>
                    </td>
                </tr>
                </tbody>
                </table>
            );
        }else{
            return(
                <table>
                <tbody>
                <tr>
                    <td colSpan="4">
                        <button className="myButton" type="button" 
                        onClick={this.saveInfo.bind(this)}><FaRegSave color={ICON_COLOR}/>
                        &nbsp;{couterpart.translate('button_save')}</button>&nbsp;&nbsp;
                        <button className="myButton" type="button" 
                        onClick={this.cloneInfo.bind(this)}><FaCopy color={ICON_COLOR}/>
                        &nbsp;{couterpart.translate('button_clone')}</button>
                    </td>
                </tr>
                </tbody>
                </table>
            );  
        }     
    }

    updateDaLenStatus(name, status){
        this.dialog.show({
            title: couterpart.translate("msg_title_confirm"),
            body: couterpart.translate("msg_change_confirm"),
            actions: [
                Dialog.CancelAction(),
                Dialog.OKAction(() =>{
                    WorkOrderDataService.updateDaLen({id: this.state.workOrder.id, statusName: name, status: status}).then(data => {
                        var msg = couterpart.translate("msg_saved_info");
                        if (data.message === undefined){
                            if (data.ret < 1){
                                msg = couterpart.translate("msg_saved_error");
                            }
                        }else{
                            msg = couterpart.translate("msg_saved_error");
                        }
                        ToastsStore.info(msg);
                        // this.loadWorkOrder(this.state.workOrder.id);
                        this.backToList();
                    });
                })
            ],
            bsSize: 'small',
            onHide: (dialog) => {
                dialog.hide()
                console.log('closed by clicking background.')
            }
        });
    }

    renderLenStatus(lenStatus){
        if (this.state.workOrder.itemType !== ITEM_TYPE_LEN_KHONG && this.state.workOrder.itemType !== ITEM_TYPE_LEN_DA && this.state.workOrder.itemType !== ITEM_TYPE_LEN_INOX) {
            return (<label style={{marginTop:"10px"}}>&nbsp;</label>);
        }

        if (lenStatus === undefined || lenStatus === null || lenStatus <= 0){
            return (<></>);
        }
        return (<label style={{marginTop:"10px"}}>{ WorkOrderUtil.getLenStatusDescription(lenStatus) }</label>);
    }

    renderDaStatus(daStatus){
        if (this.state.workOrder.itemType !== ITEM_TYPE_DA_KHONG && this.state.workOrder.itemType !== ITEM_TYPE_DA_INOX && this.state.workOrder.itemType !== ITEM_TYPE_LEN_DA) {
            return (<label style={{marginTop:"10px"}}>&nbsp;</label>);
        }

        if (daStatus === undefined || daStatus === null || daStatus <= 0){
            return (<></>);
        }
        return (<label style={{marginTop:"10px"}}>{ WorkOrderUtil.getDaStatusDescription(daStatus) }</label>);
    }

    renderEditDaButtons(){
        if (!AuthenticationService.isAdmin()){
            return (<></>);
        }

        if (this.state.workOrder.itemType === undefined || this.state.workOrder.itemType === null) {
            return (<></>);
        }

        if (this.state.workOrder.itemType !== ITEM_TYPE_DA_KHONG && this.state.workOrder.itemType !== ITEM_TYPE_DA_INOX && this.state.workOrder.itemType !== ITEM_TYPE_LEN_DA) {
            return (<></>);
        }
        
        return(
            <table>
            <tbody>
            <tr>
                <td colSpan="4">
                    <button className="myButton" type="button"  style={{marginRight:"20px"}} 
                    onClick={this.updateDaLenStatus.bind(this, STATUS_NAME_DA, STATUS_DA_MOI)}>
                    <FaRegSave color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_update_da_moi')}</button>
                </td>
                <td colSpan="4">
                    <button className="myButton" type="button"  style={{marginRight:"20px"}} 
                    onClick={this.updateDaLenStatus.bind(this, STATUS_NAME_DA, STATUS_SS_SX_DA)}>
                    <FaRegSave color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_update_da_ss')}</button>
                </td>
                <td colSpan="4">
                    <button className="myButton" type="button" 
                    onClick={this.updateDaLenStatus.bind(this, STATUS_NAME_DA, STATUS_DA_DA_SX)}>
                    <FaRegSave color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_update_da_da_sx')}</button>
                </td>
                <td colSpan="4">
                    <button className="myButton" type="button" 
                    onClick={this.updateDaLenStatus.bind(this, STATUS_NAME_DA, STATUS_DA_HOAN_THANH)}>
                    <FaRegSave color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_update_da_ht')}</button>
                </td>
            </tr>
            </tbody>
            </table>
        );
    
    }

    renderEditLenButtons(){
        if (!AuthenticationService.isAdmin()){
            return (<></>);
        }

        if (this.state.workOrder.itemType === undefined || this.state.workOrder.itemType === null){
            return (<></>);
        }

        if (this.state.workOrder.itemType !== ITEM_TYPE_LEN_KHONG && this.state.workOrder.itemType !== ITEM_TYPE_LEN_DA && this.state.workOrder.itemType !== ITEM_TYPE_LEN_INOX) {
            return (<></>);
        }
        
        return(
            <table>
            <tbody>
            <tr>
                <td colSpan="8">
                    <button className="myButton" type="button"  style={{marginRight:"20px"}} 
                    onClick={this.updateDaLenStatus.bind(this, STATUS_NAME_LEN, STATUS_LEN_MOI)}>
                    <FaRegSave color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_update_len_moi')}</button>
                </td>
                <td colSpan="4">
                    <button className="myButton" type="button" style={{marginRight:"20px"}} 
                    onClick={this.updateDaLenStatus.bind(this, STATUS_NAME_LEN, STATUS_SS_SX_LEN)}>
                    <FaRegSave color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_update_len_ss')}</button>
                </td>
                <td colSpan="4">
                    <button className="myButton" type="button" style={{marginRight:"20px"}} 
                    onClick={this.updateDaLenStatus.bind(this, STATUS_NAME_LEN, STATUS_LEN_DA_SX)}>
                    <FaRegSave color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_update_len_da_sx')}</button>
                </td>
                <td colSpan="4">
                    <button className="myButton" type="button" 
                    onClick={this.updateDaLenStatus.bind(this, STATUS_NAME_LEN, STATUS_LEN_HOAN_THANH)}>
                    <FaRegSave color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_update_len_ht')}</button>
                </td>
            </tr>
            </tbody>
            </table>
        );
    
    }

    backToList(){
        this.setState({
            backClicked: true
        });        
        if (this.state.workOrder.isDirty) {
            this.dialog.show({
                title: couterpart.translate("msg_title_confirm"),
                body: couterpart.translate("msg_change_confirm"),
                actions: [
                    Dialog.CancelAction(() => {
                        this.setState({
                            workOrder: {
                                isDirty: false
                            }
                        });
                        console.log(this.props);
                        const values = queryString.parse(this.props.location.search);
                        console.log(values);
                        console.log(values.back);
                        if (values !== undefined && "dashboard" === values.back){
                            this.props.history.push("/");
                        }else if (values !== undefined && "products" === values.back){
                            this.props.history.push("/products?isback=true");        
                        }else if (values !== undefined && "changedWo" === values.back){
                            this.props.history.push("/changedWo?isback=true");        
                        }else{
                            this.props.history.push("/orders?isback=true");
                        }                        
                    }),
                    Dialog.OKAction(() =>{
                        WorkOrderDataService.updateWorkOrder(this.state.workOrder).then(data => {
                            var msg = couterpart.translate("msg_saved_info");
                            if (data.message === undefined){
                                if (data.ret < 1){
                                    msg = couterpart.translate("msg_saved_error");
                                }
                            }else{
                                msg = couterpart.translate("msg_saved_error");
                            }
                            this.setState({
                                workOrder: {
                                    isDirty: false
                                }
                            });
                            ToastsStore.info(msg);
                            console.log(this.props);
                            const values = queryString.parse(this.props.location.search);
                            console.log(values);
                            console.log(values.back);
                            if (values !== undefined && "dashboard" === values.back){
                                this.props.history.push("/");
                            }else if (values !== undefined && "products" === values.back){
                                this.props.history.push("/products?isback=true");        
                            }else if (values !== undefined && "changedWo" === values.back){
                                this.props.history.push("/changedWo?isback=true");        
                            }else{
                                this.props.history.push("/orders?isback=true");
                            }                            
                        });
                    })
                ],
                bsSize: 'small',
                onHide: (dialog) => {
                    dialog.hide()
                    console.log('closed by clicking background.')
                    console.log(this.props);
                    const values = queryString.parse(this.props.location.search);
                    console.log(values);
                    console.log(values.back);
                    if (values !== undefined && "dashboard" === values.back){
                        this.props.history.push("/");
                    }else if (values !== undefined && "products" === values.back){
                        this.props.history.push("/products?isback=true");        
                    }else if (values !== undefined && "changedWo" === values.back){
                        this.props.history.push("/changedWo?isback=true");        
                    }else{
                        this.props.history.push("/orders?isback=true");
                    }                    
                }
            });
        }else{
            console.log(this.props);
            const values = queryString.parse(this.props.location.search);
            console.log(values);
            console.log(values.back);
            if (values !== undefined && "dashboard" === values.back){
                this.props.history.push("/");
            }else if (values !== undefined && "products" === values.back){
                this.props.history.push("/products?isback=true");        
            }else if (values !== undefined && "changedWo" === values.back){
                this.props.history.push("/changedWo?isback=true");        
            }else{
                this.props.history.push("/orders?isback=true");
            }            
        }        
    }

    reloadInfo(){
        this.loadWorkOrder(this.state.workOrder.id);
    }
    
    handleSelectStatusChange(e){
        const status = parseInt(e.target.value);
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              status: status,
              isDirty: true                  
            }
        }));
    }

    handleNotesFromAdminChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              notesFromAdmin: newValue,
              isDirty: true                   
            }
        }));
    }

    handleFontChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              font: newValue,
              isDirty: true                  
            }
        }));   
    }        

    renderStatusListForAdmin(){
        let roleName =  "";
        if (AuthenticationService.isAdmin()){
            roleName = "ADMIN";
        }else if (AuthenticationService.isService()){
            roleName = "SERVICE";
        }

        if (this.state.allStatus === undefined || this.state.allStatus === null){
            return (<></>);
        }
        let adminStatus = this.state.allStatus.filter(y =>{
            return ((y.type === 2) && (y.usedBy.indexOf(roleName) >= 0))
        });
        // console.log('adminStatus', adminStatus);
        return (
            <select value={this.state.workOrder.status} className="selectBox"
                onChange={this.handleSelectStatusChange.bind(this)}>
                {   
                    adminStatus.map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)
                }
            </select> 
        );
    } 

    getOrderNote(note){
        let idx = note.indexOf('order_note');
        if (idx >= 0){
            let dt = "";
            if (note.length > 18){
                dt = note.substring(0, 18) + ': ';
            }

            let orderNote = note.substring(idx);
            let idx2 = orderNote.indexOf('->');
            if (idx2 >= 0){
                let s = orderNote.substring(idx2)
                let idx3 = s.indexOf('\n\r  ');
                if (idx3 >= 0){
                    return dt + orderNote.substring(0, idx2 + idx3)
                }
                return dt + orderNote
            }
            return dt + orderNote;
        }
        return note;
    }

    renderNotes(){
        if (this.state.notes === undefined){
            return "";
        }

        let s = "";
        for(let i=0; i< this.state.notes.length; i++){
            s += this.getOrderNote(this.state.notes[i].note) + "\r\n";
        }
        return s;
    } 

    handleBlockedNavigation = (nextLocation) => {
        // let vm = this;
        this.dialog.show({
            title: couterpart.translate("msg_title_confirm"),
            body: couterpart.translate('dialog_leave_msg'),
            actions: [
                Dialog.CancelAction(() => {
                    this.setState({
                            workOrder: {
                                isDirty: false
                            }
                        }) 
                    return false;
                }),
                Dialog.OKAction(() =>{
                    WorkOrderDataService.updateWorkOrder(this.state.workOrder).then(data => {
                        var msg = couterpart.translate("msg_saved_info");
                        if (data.message === undefined){
                            if (data.ret < 1){
                                msg = couterpart.translate("msg_saved_error");
                            }
                        }else{
                            msg = couterpart.translate("msg_saved_error");
                        }
                        ToastsStore.info(msg);
                        this.setState({
                            workOrder: {
                                isDirty: false
                            }
                        })
                        return true;                        
                    });
                })
            ],
            bsSize: 'small',
            onHide: (dialog) => {
                dialog.hide();
                return true;                  
            }
        });
        return false;
    }

    renderIncident(s){
        if (s === null || s === undefined){
            return '';
        }
        const info = s.split('$');
        let text = info.join(', ');
        return text;
    }

    renderAssignedWorkerRow(assignedWorker) {
        if  (assignedWorker.department === null || assignedWorker.department === undefined || assignedWorker.department.length < 1){
            return (
                <div classname="row">
                    { assignedWorker.username }
                </div>
            );
        }

        return (
            <div classname="row">
                { assignedWorker.username + "(" + assignedWorker.department + ")" }
            </div>
        );
    }

    handleHanSx(date) {
        this.setState({
            prodDeadline: date
        });
    }

    updateHanSx() {
        this.dialog.show({
            title: couterpart.translate("msg_title_confirm"),
            body: couterpart.translate("msg_to_update_hansx_confirm"),
            actions: [
                Dialog.CancelAction(),
                Dialog.OKAction(() => {
                    try {
                        WorkOrderDataService.updateHanSx({ workOrderId: this.state.workOrderId, prodDeadLine: WorkOrderUtil.convertToyyyyMMddhhmmString(this.state.prodDeadline) }).then(data => {
                            this.loadWorkOrder(this.state.workOrderId);
                        });
                    } catch (e) {
                    }
                })
            ],
            bsSize: 'small',
            onHide: (dialog) => {
                dialog.hide()
                console.log('closed by clicking background.')
            }
        });
    }

    getAssignedWorkers(wo){
        if (wo.itemType === undefined || wo.itemType === null || wo.itemType <= ITEM_TYPE_NONE){
            return (<> { wo.workerFullName } </>)
        }

        if (wo.assignedWorkers == null || wo.assignedWorkers.length < 1){
            return "";
        }
        try {
            return(
            <>
                <div classname='col-12'>
                    {wo.assignedWorkers.map(assignedWorker => this.renderAssignedWorkerRow(assignedWorker))}
                </div>
            </>
            );
        } catch (e) {

        }
        return "";
    }         
      
    render() {
        if (!AuthenticationService.isAdmin() && !AuthenticationService.isService() && !AuthenticationService.isDesigner()){
            return (<div>Unauthorized access.</div>);
        }

        if (this.state.workOrderId === null){
            return (<></>);
        }

        //const { selectedOption } = this.state.selectedOption;
        if (this.state.workOrder.workOrderNo !== undefined){
            return (
                <div style={{margin:"5px"}}>
                <MenuComponent2/>
                <ToastsContainer store={ToastsStore} position="bottom_center" />
                <div style={{padding:"5px"}}>
                    <button className="myButton" onClick={this.backToList.bind(this)}>
                        <TiArrowBackOutline color={ICON_COLOR}/>&nbsp;
                        {couterpart.translate('button_back')}&nbsp;&nbsp;&nbsp;&nbsp;</button>&nbsp;&nbsp;
                    <button className="myButton" onClick={this.reloadInfo.bind(this)}>
                        <TiRefresh color={ICON_COLOR}/>&nbsp;
                        {couterpart.translate('button_reload')}&nbsp;&nbsp;&nbsp;&nbsp;</button>
                </div>
                <div className="row">
                    <div className="col-8">
                        <div className="row">
                            <div className="col-3 border-top border-left border-light-gray">
                                <div className="row">
                                    <img alt="" src={"data:image/gif;base64," + this.state.workOrder.qrCode}/>
                                </div>
                                <div className="row">
                                    {this.state.workOrder.workOrderNo}
                                </div>
                            </div>
                            <div className="col-1 border-top border-left border-light-gray">
                                <div className="row border-bottom border-light-gray">
                                    <label className="labelBox_red">
                                        {couterpart.translate('work_order_urgent_level')}
                                    </label>
                                </div>
                                <div className="row">
                                    <label style={{color:'red', margin: '2px'}}>{this.state.workOrder.urgent}</label>
                                </div>                                                    
                            </div>
                            <div className="col-6 border-top border-left border-light-gray">
                                <div className="row border-bottom border-light-gray">
                                    <div className="col-3"> 
                                        <label className="labelBox">{couterpart.translate('work_order_order_date_s')}</label>
                                    </div>
                                    <div className="col border-left border-right border-light-gray">
                                        <label className="labelValueBox">
                                            {WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.orderDate)}
                                        </label>
                                    </div>
                                </div>
                                <div className="row border-bottom border-light-gray">
                                    <div className="col-3">
                                        <label className="labelBox">
                                            {couterpart.translate('work_order_web_dealine')}
                                        </label>
                                    </div>
                                    <div className="col border-left border-right border-light-gray">
                                        <label className="labelValueBox">
                                            { WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineWeb) } 
                                        </label>
                                    </div>
                                </div>
                                <div className="row border-bottom border-light-gray">
                                    <div className="col-3">
                                        <label className="labelBox">
                                            {couterpart.translate('work_order_etsy_dealine')}
                                        </label>
                                    </div>
                                    <div className="col border-left border-right border-light-gray">
                                        <label className="labelValueBox">
                                            { WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.etsy) } 
                                        </label>
                                    </div>
                                </div>
                                <div className="row border-bottom border-light-gray">
                                    <div className="col-3">                            
                                        <label className="labelBox">{couterpart.translate('work_order_worker')}</label>
                                   </div>
                                    <div className="col border-left border-right border-light-gray">
                                        { this.getAssignedWorkers (this.state.workOrder) }
                                        {/* {this.renderWorkerByRole()} */}
                                    </div>
                                </div>
                                {/* <div className="row border-bottom border-light-gray">
                                    <div className="col"> 
                                        <label className="labelBox">{couterpart.translate('work_order_start_date')}</label>
                                    </div>
                                    <div className="col border-left border-right border-light-gray">
                                        <DatePicker className="datePicker"
                                            selected={ WorkOrderUtil.convertToDate(this.state.workOrder.startDate)}
                                            name="startDate"
                                            dateFormat="MM/dd/yyyy hh:mm"
                                            onChange={this.handleStartDateChange.bind(this)}
                                        />                            
                                    </div>
                                </div> */}
                                <div className="row border-bottom border-light-gray">
                                    <div className="col-3">
                                        <label className="labelBox">{couterpart.translate('work_order_prod_dealine')}</label>
                                    </div>
                                    <div className="col border-left border-right border-light-gray">
                                        <div className='row'>
                                            <div className='col-4'>
                                                <label className="labelValueBox">
                                                    { WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineTs) }
                                                </label>
                                            </div>
                                            <div  className="col border-left border-right border-light-gray">
                                                <DatePicker name="prodDeadline"
                                                    placeholderText={'Chọn hạn sản xuất mới'}
                                                    dateFormat="MM/dd/yyyy" 
                                                    selected={ this.state.prodDeadline }
                                                    onChange={ this.handleHanSx.bind(this) } 
                                                    />&nbsp;&nbsp;&nbsp;
                                                    <button className="myButton"
                                                        onClick={this.updateHanSx.bind(this)}>
                                                        <MdImportExport color={ICON_COLOR} />{ "Cập nhật" }
                                                    </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row border-bottom border-light-gray">
                                    <div className="col-3">
                                        <label className="labelBox">{couterpart.translate('work_ngay_nhap_lieu')}</label>
                                    </div>
                                    <div className="col border-left border-right border-light-gray">
                                        <label className="labelValueBox">{
                                            WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.ngayNhapLieuTs) 
                                        }</label>
                                    </div>
                                </div>                                                            
                            </div>
                        </div>                        
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('work_order_code')}</label>
                            </div>
                            <div className="col-3 border-top border-left border-light-gray">
                                {this.renderItemList()}
                            </div>                          
                            <div className="col-1 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('shop_pcode')}</label>
                            </div>
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelValueBox">{this.state.workOrder.fullPCode}</label>
                            </div>
                            <div className="col-1 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('work_order_font')}</label>
                            </div>
                            <div className="col-2 border-top border-left border-right border-light-gray">
                                {this.renderFontList()}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('work_order_color')}</label>
                            </div>
                            <div className="col-2 border-top border-left border-light-gray">
                                {this.renderColorList()}
                            </div>
                            <div className="col-1 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('work_order_type')}</label>
                            </div>
                            <div className="col-3 border-top border-left border-light-gray">
                                {this.renderTypeList()}
                            </div>
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox_red">{couterpart.translate('work_order_urgent_by_cust')}</label>
                            </div>
                            <div className="col-1 border-top border-left border-right border-light-gray">
                                <input type="checkbox" name="isUrgentByCustomer" className="inputBox"
                                    defaultChecked={this.state.workOrder.isUrgentByCustomer}
                                    onChange={this.handleUrgentChange.bind(this)}/>
                            </div>                            
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray">
                                <label className="labelBox_red">{couterpart.translate('work_order_quantity_s')}</label>
                            </div>
                            <div className="col-2 border-top border-left border-light-gray">
                                <input type="text" name="qty" size="5" className="inputBox"
                                    defaultValue={this.state.workOrder.qty}
                                    onChange={this.handleQtyChange.bind(this)}/>
                                </div>
                            <div className="col-1 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('work_order_size')}</label>
                            </div>
                            <div className="col-3 border-top border-left border-light-gray">
                                <input type="text" name="lengthSize" className="inputBox"
                                    defaultValue={this.state.workOrder.lengthSize}
                                    onChange={this.handleLengthSizeChange.bind(this)}/>
                                </div>
                            <div className="col-1 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('work_order_shipto')}</label>
                            </div>
                            <div className="col-2 border-top border-left border-right border-light-gray">
                                <input type="text" name="lengthSize" className="inputBox"
                                    defaultValue={this.state.workOrder.shipTo}
                                    onChange={this.handleShipToChange.bind(this)}/>
                                </div>                                                            
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('work_order_customer_s')}</label>
                            </div>
                            <div className="col-3 border-top border-left border-light-gray">
                                <label className="labelValueBox">{this.state.workOrder.customer}</label>
                            </div>
                            <div className="col-1 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('work_order_urgent')}</label>
                            </div>
                            <div className="col-2 border-top border-left border-right border-light-gray">
                                {this.renderShippingList()}
                            </div>
                            <div className="col-3">
                                <div className="row">
                                    <div className="col-8 border-top border-left border-light-gray">
                                        <label className="labelBox">{couterpart.translate('work_order_design_level')}</label>
                                    </div>
                                    <div className="col-4 border-top border-left border-right border-light-gray">
                                        {this.renderDesignLevelList()}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-4 border-top border-left border-light-gray">
                                        <label className="labelBox">{couterpart.translate('work_order_designer')}</label>
                                    </div>
                                    <div className="col-8 border-top border-left border-right border-light-gray">
                                        <label className="labelValueBox">{this.state.workOrder.designer}</label>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">
                                    {couterpart.translate('work_order_personalization')}
                                </label>
                            </div>
                            <div className="col-8 border-top border-left border-right border-light-gray">
                                <textarea name="name" className="form-control textArea" id="name" 
                                    placeholder="Some note" 
                                    value={this.state.workOrder.personalization === null? '' : this.state.workOrder.personalization} 
                                    onChange={this.handlePersonalizationChange.bind(this)} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('work_order_special_note')}</label>
                            </div>
                            <div className="col-8 border-top border-left border-right border-light-gray">
                                <textarea name="notesInternal" className="form-control textArea" id="notesInternal" 
                                    placeholder="Some special note" 
                                    value={this.state.workOrder.notesInternal? this.state.workOrder.notesInternal : ''} 
                                    onChange={this.handleSpecialNoteChange.bind(this)} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('work_order_ycdb_shipping')}</label>
                            </div>
                            <div className="col-6 border-top border-left border-right border-light-gray">
                                <textarea name="name" className="form-control textArea" id="name" 
                                    placeholder="Ghi chú đặc biệt" 
                                    value={this.state.workOrder.ycdbShipping? this.state.workOrder.ycdbShipping : ''} 
                                    onChange={this.handleYcdbShippingChange.bind(this)} />
                            </div>
                            <div className="col-1 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('lbl_da_ghi_thiep')}</label>
                            </div>
                            <div className="col-1 border-top border-left border-right border-light-gray">
                                <div className='row'>
                                    <div className='col-12'>
                                      <input type="checkbox" name="ghiThiep" className="inputBox"
                                        defaultChecked={this.state.workOrder.ghiThiep === '1'? 1 : 0}
                                        onChange={this.handleGhiThiepChange.bind(this)}/>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12'>
                                        <label style={{ marginLeft: "30px", marginTop: "40px"}}><b>{  this.state.workOrder.weightOZ }</b></label>
                                    </div>
                                </div>
                            </div>
                        </div>                         
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">{couterpart.translate('label_note')}</label>
                            </div>
                            <div className="col-8 border-top border-left border-right border-light-gray">
                                <textarea name="notesFromAdmin" className="form-control textArea" id="notesFromAdmin" 
                                    placeholder="Some special note" 
                                    value={this.state.workOrder.notesFromAdmin? this.state.workOrder.notesFromAdmin : ''} 
                                    onChange={this.handleNotesFromAdminChange.bind(this)} />                                
                            </div>
                        </div>                         
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">{ couterpart.translate('work_order_status') }</label>
                            </div>                            
                            <div className="col-4">
                                <div className="row">
                                    <div className="col-12 border-top border-left border-right border-light-gray">
                                        <label className="labelBox">{ WorkOrderUtil.getStatusDescription(this.state.allStatus, this.state.workOrder.status)}</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 border-top border-left border-right border-light-gray">
                                        { this.renderStatusListForAdmin() } 
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 border-top border-left border-right border-light-gray">
                                        {this.renderEditButtons()}
                                    </div>
                                </div>                                
                            </div>

                            <div className="col-4 border-top border-left border-light-gray border-right">
                                <label className="labelBox">{ couterpart.translate('incident') }: </label>
                                <p>{ this.renderIncident(this.state.workOrder.fillSKU) } </p>
                            </div> 
                            
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">{ couterpart.translate('work_order_itype') }</label>
                            </div>                            
                            <div className="col-2 border-top border-left border-right border-light-gray">
                                { WorkOrderUtil.getItemTypeDescription(this.state.workOrder.itemType) }
                            </div>
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">{ couterpart.translate('work_order_error_code') }</label>
                            </div>                            
                            <div className="col-2 border-top border-left border-right border-light-gray">
                                { DataUtil.getErrorDescription(this.state.workOrder.errorCode) }
                            </div>
                            <div className="col-2 border-top border-left border-right border-light-gray">
                                <div className='row'>
                                    <div className='col-12'>
                                        { "Đơn mùa:" + (this.state.workOrder.donMua === null || this.state.workOrder.donMua === undefined? "" : this.state.workOrder.donMua) }
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12'>
                                        {"Hạn giao mùa: " + this.state.workOrder.hanGiaoMua }
                                    </div>
                                </div>
                                
                            </div>                        
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">{ couterpart.translate('work_order_status_len') }</label>
                            </div>                            
                            <div className="col-8">
                                <div className="row">
                                    <div className="col-2 border-top border-left border-right border-light-gray">
                                        { this.renderLenStatus(this.state.workOrder.lenStatus) }
                                    </div>
                                    <div className="col-10 border-top border-left border-right border-light-gray">
                                        { this.renderEditLenButtons() }
                                    </div>
                                </div>                              
                            </div>                            
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">{ couterpart.translate('work_order_status_da') }</label>
                            </div>                            
                            <div className="col-8">
                                <div className="row">
                                    <div className="col-2 border-top border-left border-right border-light-gray">
                                        { this.renderDaStatus(this.state.workOrder.daStatus) }
                                    </div>
                                    <div className="col-10 border-top border-left border-right border-light-gray">
                                        {this.renderEditDaButtons()}
                                    </div>
                                </div>                              
                            </div>                            
                        </div>
                        <div className="row">
                            <div className="col-10 border-top border-left border-right border-bottom border-light-gray">
                                <TalkDetails workOrderId={this.state.workOrderId} sender="service" />
                            </div>
                        </div>
                        <div className="row" style={{marginTop:"10px"}}>
                            <div className="col-10 border-top border-left border-right border-bottom border-light-gray">
                                <label htmlFor="">Hinh Khach: { this.state.workOrder.imageURL }</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-10 border-top border-left border-right border-bottom border-light-gray">
                                <WorkOrderAdditions mode="MODE_EDIT" 
                                    caption={couterpart.translate('work_order_additions')} 
                                    workOrderId={this.state.workOrderId} 
                                    isUpdated={this.state.updated}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-10 border-top border-left border-right border-bottom border-light-gray">
                                <br/>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    >
                                    <Typography>{couterpart.translate('work_order_original_info')}</Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <p>
                                            {couterpart.translate('work_order_quantity_s')}: {this.state.workOrder.originalQty} <br/>
                                            {couterpart.translate('work_order_code')}: {this.state.workOrder.originalSKU} <br/>
                                            {couterpart.translate('work_order_customer_note')}: {this.state.workOrder.notesFromBuyer} <br/>
                                            {couterpart.translate('work_order_urgent')}: {this.state.workOrder.originalServiceRequested}<br/>
                                            {couterpart.translate('work_order_options')}: {this.state.workOrder.options}
                                        </p>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    >
                                    <Typography>{couterpart.translate('label_note')}</Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <pre className="note-items">
                                            { this.renderNotes() }
                                        </pre>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <br/>
                            </div>                             
                        </div>                                                                                                                       
                    </div>
                    <div className="col-4">                
                        <div className="row">
                            <WorkOrderImages mode="MODE_EDIT" largeMode={1}  
                                workOrderId={this.state.workOrderId} 
                                isUpdated={this.state.updated}/>
                        </div>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <ItemDetailsViewById itemSku={this.state.workOrder.sku}/>
                        </div>                                                                         
                    </div>                    
                </div>
                <Dialog ref={(component) => { this.dialog = component }} />
            </div>
            );
        }else{
            return (<div>&nbsp;</div>)
        }
    }
}

export default withRouter(WorkOrderDetails);